import React from "react";
import { Button } from "@mui/material";

const ncocLogo = new URL(
    'ncoc-logo.svg',
    import.meta.url
  );

const LandingPage = () => {
    return (<div className="loginpage">
        <div className="logoPanel">
            <img className="logo" src={ncocLogo.href} alt="NCOC Logo" />
            <span>Kashagan East weather and water level</span>
        </div>
        <Button
            variant="contained"
            onClick={() => { window.location.href="/display"; }}>
            Log in
        </Button>
    </div>);
};

export default LandingPage;